/**
 *
 * @description: 招商基金
 *
 */

import { isBuild } from '@/apis/host';
import { isThirdPartyMode, BridgeBase } from './bridge_utils';

const brmChannel = 'zszq';

const comein_channel = isBuild ? '748112da-0365-4807-b8fe-44ee3498f7b9' : 'c59431ae-cf46-4993-86be-b9dc74d7a94d';

export const isThirdParty = isThirdPartyMode({ brmChannel, comein_channel });

if (isThirdParty) window.comeinChannel = 'zszq';

class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, false);

    this.jinbaoModules = {
      claw: {
        showOpenClaw: true,
        disableOpenClawChatLinks: true
      }
    };
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

export { Bridge };
